// OpenSummaryButton.js


import React, { useState } from 'react';
import { Tip, Box, Text } from "grommet";

const OpenSummaryButton = ({ evaluationMaxGrade, el, showEvaluationSummary, setSelectedEvaluation }) => {
    const [borderSize, setBorderSize] = useState('xsmall');

    return (

        <Tip  
            content={<Box style={{fontWeight: "bold", background: "rgba(204, 204, 204, .6)", padding: "5px",  borderRadius: "8px"}}>
            Open Evaluation Summary
            </Box>}
            plain
        >
        <Box pad="xxsmall" width= "36px" margin="xxsmall" align="center" round={true} 
            hoverIndicator 
            border={evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade ? { color: '#f0869c', size: `${borderSize}` } : { color: `${el.gradeColor}`, size: `${borderSize}`}}
            style= {{                
                background: evaluationMaxGrade !== 0 && el.evaluationGrade === evaluationMaxGrade
                        ? `radial-gradient(${el.gradeColor} 50%, ${el.gradeColor} 30%, #9F3766 90%)` 
                        : el.gradeColor
            }}

            onMouseOver={() => {setBorderSize('2px');}}
            onMouseOut={() => {setBorderSize('xsmall');}}
            onClick={() => {showEvaluationSummary(true); setSelectedEvaluation(el)}}
            >

            <Text 
                fill="horizontal"
                color= 'brand'
                weight="bold" >{el.evaluationGrade}
            </Text>
        </Box>
    </Tip>  
  );
};

export default OpenSummaryButton;